import React, { useState } from "react";
import GamesCarousel from "../module/GamesCarousel";
import { type GameDTO, GameThumbnailDTO } from "../../../../model/GameDTO";
import KC_Button, {
  KC_ButtonSize,
  KC_ButtonType
} from "../../../../designsystem/KC_Button/KC_Button";
import { Config } from "kadow-jetpack-model";
import { tt } from "../../../../utils/i18n/i18n";

interface Props {
  handleGoBack: () => void;
  handleSubmit: (values: any) => void;
  gamesList: GameThumbnailDTO[];
  useSubmit: boolean;
  selectedGames?: GameDTO[];
  selectedEvent?: string;
  jetpackConfig: Config | null;
  hasSkins: boolean;
}

export default function GamesSelectorNoFormikWrapper(props: Props) {
  const [selectedGames, setSelectedGames] = useState<GameThumbnailDTO[]>([]);

  const handleSubmit = () => {
    props.handleSubmit(selectedGames);
  };

  const handleSelectedGame = (game: GameThumbnailDTO) => {
    if (selectedGames.includes(game)) {
      setSelectedGames([]);
      return;
    }
    setSelectedGames([game]);
  };

  const isGameSelected = (game: GameThumbnailDTO) => {
    return selectedGames.some((g) => g.name === game.name);
  };

  return (
    <div id="ml-game-list" className="mt-4 d-flex flex-column gap-sm">
      <div className="w-100">
        <div className="pb-1">
          <GamesCarousel
            displayedGames={props.gamesList}
            isGamesSelectable={true}
            onGameSelect={handleSelectedGame}
            onSubmit={handleSubmit}
            handleGoBack={props.handleGoBack}
            submitBtnTitle={
              props.hasSkins ? tt("choose_a_skin") : tt("form_button_add")
            }
            useSubmit={true}
            isGameSelected={isGameSelected}
          />
        </div>
      </div>
      <div className="w-100">
        {props.useSubmit && (
          <div className="w-100 d-flex justify-content-end gap-sm border-top p-2">
            <div>
              <KC_Button
                type={KC_ButtonType.Submit}
                isPrimary={true}
                size={KC_ButtonSize.Large}
                text={tt("next")}
                className="d-flex"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
